import { HttpMethod } from "@/types/https";
import { apiWorkchestraCall } from "../base";
import { ENDPOINT } from "../endpoints";
import {
  GetNotificationsParams,
  GetNotificationsResponse,
  GetNotificationsTotalUnreadResponse,
  MarkAsReadResponse,
} from "../types/notification.type";

export const fetchNotifications = async (
  params: GetNotificationsParams = {}
): Promise<GetNotificationsResponse> => {
  return apiWorkchestraCall<GetNotificationsResponse>({
    url: ENDPOINT.NOTIFICATIONS_ME,
    method: HttpMethod.GET,
    params: {
      relatedObjectName: params.relatedObjectName,
      itemsPerPage: params.itemsPerPage ?? 10,
    },
  });
};

export const fetchTotalUnreadNotifications = 
  async (): Promise<GetNotificationsTotalUnreadResponse> => {
    return await apiWorkchestraCall<GetNotificationsTotalUnreadResponse>({
      url: ENDPOINT.NOTIFICATIONS_ME_TOTAL_UNREAD,
      method: HttpMethod.GET,
    });
  };

export const markNotificationAsRead = async (
  notificationIds: string
): Promise<MarkAsReadResponse> => {
  return apiWorkchestraCall<MarkAsReadResponse>({
    url: `${ENDPOINT.NOTIFICATION_READ}/${notificationIds}/read`,
    method: HttpMethod.PUT,
  });
};

export const markNotificationAsUnread = async (
  notificationIds: string
): Promise<MarkAsReadResponse> => {
  return apiWorkchestraCall<MarkAsReadResponse>({
    url: `${ENDPOINT.NOTIFICATION_READ}/${notificationIds}/unread`,
    method: HttpMethod.PUT,
  });
};

export const deleteNotification = async (
  notificationIds: string
): Promise<MarkAsReadResponse> => {
  return apiWorkchestraCall<MarkAsReadResponse>({
    url: `${ENDPOINT.NOTIFICATION_READ}/${notificationIds}`,
    method: HttpMethod.DELETE,
  });
};

export const markAllNotificationsAsRead =
  async (): Promise<MarkAsReadResponse> => {
    return apiWorkchestraCall<MarkAsReadResponse>({
      url: ENDPOINT.NOTIFICATIONS_MARK_ALL_READ,
      method: HttpMethod.PUT,
    });
  };
